<app-leveltwo [pageName]="'Change in Ownership'">
    <div heading="General Info" class="General">
      <h3>{{'ChangeinOwnership.PageTitle'|translate}}</h3>
      <p>{{'ChangeinOwnership.allproperties1'|translate}}</p>
      <p>{{'ChangeinOwnership.allproperties2'|translate}}</p>

      <div class="accordion">
        <accordion [isAnimated]="true" >
        <accordion-group #drop [isOpen]="true">
          <div accordion-heading >
            <span class="dropdown-item clearfix">
              {{'ChangeinOwnership.ChangesandNotification'|translate}} <i class="mt-1 float-end" [ngClass]="!drop.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
            </span>
          </div>

        <h4>{{'ChangeinOwnership.ChangesandNotification'|translate}}</h4>
            <p>{{'ChangeinOwnership.ChangesandNotification1'|translate}}</p>
            <p>{{'ChangeinOwnership.ChangesandNotification2'|translate}}<b>{{'ChangeinOwnership.ChangesandNotification2bold'|translate}}</b></p>

            <p [innerHTML]="'ChangeinOwnership.Ownersofa'|translate"></p>
            <p [innerHTML]="'ChangeinOwnership.Note'|translate"></p>

        </accordion-group>
        <accordion-group #drop2>
          <div accordion-heading >
            <span class="dropdown-item clearfix">
              {{'ChangeinOwnership.Exclusions'|translate}} <i class="mt-1 float-end" [ngClass]="!drop2.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
            </span>
          </div>
            <h4>{{'ChangeinOwnership.Exclusions'|translate}}</h4>
              <p>{{'ChangeinOwnership.Exclusionstext'|translate}}</p>
        </accordion-group>
        <accordion-group #drop3>
          <div accordion-heading >
            <span class="dropdown-item clearfix">
              {{'ChangeinOwnership.ChangesClaim'|translate}} <i class="mt-1 float-end" [ngClass]="!drop3.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
            </span>
          </div>
          <h4>{{'ChangeinOwnership.ChangeswithClaim'|translate}}</h4>
            <ol>
              <li>
                <p><b>{{'ChangeinOwnership.ChangeswithClaim1'|translate}}</b> {{'ChangeinOwnership.ChangeswithClaim1text'|translate}}</p>
              </li>
              <li>
                <p><b>{{'ChangeinOwnership.ChangeswithClaim2'|translate}}</b> {{'ChangeinOwnership.ChangeswithClaim2text'|translate}}</p>
              </li>
              <li>
                <p><b>{{'ChangeinOwnership.ChangeswithClaim3'|translate}}</b> {{'ChangeinOwnership.ChangeswithClaim3text'|translate}}</p>
                <p><b>{{'ChangeinOwnership.ChangeswithClaimNote'|translate}}</b> {{'ChangeinOwnership.ChangeswithClaimNotetext'|translate}}</p>
                <button type="button" class="btn btn-primary" routerLink="/homeowners/proposition-19">{{'ChangeinOwnership.Prop19Clickhere'|translate}}</button>
                <br><br>
              </li>
              <li>
                <p>{{'ChangeinOwnership.ChangeswithClaim4'|translate}}</p>
                  <ul>
                    <li>
                      <p>{{'ChangeinOwnership.ChangeswithClaim4item1'|translate}}</p>
                    </li>
                    <li>
                      <p>{{'ChangeinOwnership.ChangeswithClaim4item2'|translate}}</p>
                    </li>
                    <li>
                      <p>{{'ChangeinOwnership.ChangeswithClaim4item3'|translate}}</p>
                    </li>
                    <li>
                      <p>{{'ChangeinOwnership.ChangeswithClaim4item4'|translate}}</p>
                    </li>
                    <li>
                      <p>{{'ChangeinOwnership.ChangeswithClaim4item5'|translate}}</p>
                    </li>
                  </ul>
              </li>
              <li>
                <p>{{'ChangeinOwnership.ChangeswithClaim5'|translate}}</p>
              </li>
              <li>
                <p>{{'ChangeinOwnership.ChangeswithClaim6'|translate}}</p>
              </li>
            </ol>
        </accordion-group>

        <accordion-group #drop4>
          <div accordion-heading >
            <span class="dropdown-item clearfix">
              {{'ChangeinOwnership.ChangesExcl'|translate}} <i class="mt-1 float-end" [ngClass]="!drop4.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>
            </span>
          </div>
            <h4>{{'ChangeinOwnership.ChangesExcluded'|translate}}</h4>
            <ol>
              <li>
                <p>{{'ChangeinOwnership.ChangesExcludeditem1'|translate}}</p>
              </li>
              <li>
                <p>{{'ChangeinOwnership.ChangesExcludeditem2'|translate}}</p>
              </li>
              <li>
                <p>{{'ChangeinOwnership.ChangesExcludeditem3'|translate}}</p>
              </li>
              <li>
                <p>{{'ChangeinOwnership.ChangesExcludeditem4'|translate}}</p>
              </li>
              <li>
                <p>{{'ChangeinOwnership.ChangesExcludeditem5'|translate}}</p>
              </li>
              <li>
                <p>{{'ChangeinOwnership.ChangesExcludeditem6'|translate}}</p>
              </li>
              <li>
                <p>{{'ChangeinOwnership.ChangesExcludeditem7'|translate}}</p>
              </li>
              <li>
                <p>{{'ChangeinOwnership.ChangesExcludeditem8'|translate}}</p>
              </li>
              <li>
                <p>{{'ChangeinOwnership.ChangesExcludeditem9'|translate}}</p>
              </li>
              <li>
                <p>{{'ChangeinOwnership.ChangesExcludeditem10'|translate}}</p>
              </li>
              <li>
                <p>{{'ChangeinOwnership.ChangesExcludeditem11'|translate}}</p>
              </li>
              <li>
                <p>{{'ChangeinOwnership.ChangesExcludeditem12'|translate}}</p>
              </li>
            </ol>
          </accordion-group>
        </accordion>
      </div>

    </div>


</app-leveltwo>
